module.exports = "/_next/static/images/fiberAndCoaxialSplicing-7c79276d920ef452f00805d1d6f6db39.webp";